export default __webpack_public_path__ + "static/insta-b02b569a7ae99e079e51f50e5d93b3f3.svg";